import isEmpty from 'lodash/isEmpty'
import pick from 'lodash/pick'
import type { BusinessType } from 'src/types/business'

export const getBusinessContextValue = (config: unknown) => {
  const contextValue = pick(config, [
    'mobileRate',
    'affiliateId',
    'utmMedium',
    'rateModel',
    'referrer',
  ]) as {
    mobileRate: boolean
    affiliateId: string
    utmMedium: string
    rateModel?: string
    referrer: string
  }

  if (isEmpty(contextValue)) {
    return null
  }

  const { mobileRate, affiliateId, utmMedium, rateModel, referrer } = contextValue

  return { mobileRate, affiliate: affiliateId, utmMedium, rateModel, referrer } as BusinessType
}
